import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useVersionCheck } from '../hooks/useVersionCheck';

// Auto-reload countdown. Long enough that someone mid-typing can hit
// "Not now" without losing their thought; short enough that idle tabs
// catch up quickly.
const AUTO_RELOAD_SECONDS = 60;

export const DeployUpdateBanner = () => {
  const { stale } = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(AUTO_RELOAD_SECONDS);

  useEffect(() => {
    if (!stale || dismissed) return;
    if (secondsLeft <= 0) {
      window.location.reload();
      return;
    }
    const id = window.setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => window.clearTimeout(id);
  }, [stale, dismissed, secondsLeft]);

  if (!stale || dismissed) return null;

  const reload = () => window.location.reload();

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 flex items-center gap-3 border-b border-brand-orange/30 bg-brand-orange/10 px-4 py-2 text-sm text-text-primary"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-brand-orange" aria-hidden="true" />
      <span className="flex-1">
        <span className="font-semibold">New version of OneDesk is available.</span>{' '}
        <span className="text-text-secondary">
          Reloading in {secondsLeft}s so you can see the latest features.
        </span>
      </span>
      <button
        type="button"
        onClick={reload}
        className="rounded-md bg-brand-orange px-3 py-1 text-xs font-semibold text-white hover:bg-brand-orange-dark"
      >
        Reload now
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss — I'll reload later"
        className="grid h-7 w-7 place-items-center rounded text-text-secondary hover:bg-bg-secondary"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
